import { render } from "./AllRowdyList.vue?vue&type=template&id=b165ea44&scoped=true"
import script from "./AllRowdyList.vue?vue&type=script&lang=js"
export * from "./AllRowdyList.vue?vue&type=script&lang=js"

import "./AllRowdyList.vue?vue&type=style&index=0&id=b165ea44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b165ea44"]])

export default __exports__